import axios from "axios";
import { Env } from "../config";

const axiosClient = axios.create({
    baseURL: Env.REACT_APP_API_BASE_URL,
    timeout: 15000,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

axiosClient.interceptors.response.use(
    (response) => response.data,
    (error) => {
        return Promise.reject({
            message:
                error.response?.data?.message ||
                error.message ||
                "Something went wrong",
            status: error.response?.status,
            data: error.response?.data,
        });
    }
);

export default axiosClient;